import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OtpService } from 'src/app/service/otp.service';
import { RegisteredRetailer } from 'src/app/models/registered-retailer.model';
import { RetailerService } from 'src/app/service/retailer.service';
import { RetailerDataStoreService } from 'src/app/service/retailer-data-store.service';
import { RetailerFilter } from 'src/app/models/retailer-filters.model';
import { Location } from '@angular/common';
@Component({
  selector: 'app-generate-otp',
  templateUrl: './generate-otp.component.html',
  styleUrls: ['./generate-otp.component.scss']
})
export class GenerateOtpComponent implements OnInit {
  phoneNumber: string = '';
  isPhoneNumberValid: boolean = false;
  isEditFlow: boolean = false;
  isLoading: boolean = false;
  existingRetailers: RegisteredRetailer[] = []; 
  showExistingRetailers: boolean = false; 
  pageIndex: number = 0; 
  pageSize: number = 10; 
  isSubmitClicked: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private otpService: OtpService,
    private retailerService: RetailerService,
    private snackBar: MatSnackBar,
    private retailerDataStore: RetailerDataStoreService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['primaryMobile']) {
        this.phoneNumber = params['primaryMobile'];
        this.isEditFlow = params['isEditFlow'] === 'true';
        this.isPhoneNumberValid = this.phoneNumber.startsWith('0') ? (this.phoneNumber.length === 10) : (this.phoneNumber.length === 9);
      }
    });
  }

  onPhoneNumberInput(): void {
    this.phoneNumber = this.phoneNumber.replace(/[^0-9]/g, '');
    this.isPhoneNumberValid = this.phoneNumber.startsWith('0') ? (this.phoneNumber.length === 10) : (this.phoneNumber.length === 9);
    // Hide existing retailers list if phone number is being re-typed
    this.showExistingRetailers = false;
    this.existingRetailers = [];
  }

  onVerifyPhoneNumber(): void {
    if (!this.isPhoneNumberValid) {
      this.snackBar.open('Please enter a valid 9-digit phone number.', 'Dismiss', { duration: 3000 });
      return;
    }
    if(this.phoneNumber.length === 10) {
      this.phoneNumber = this.phoneNumber.substring(1);
    }
    if (!this.isEditFlow && !this.isSubmitClicked) {
      this.searchExistingRetailers(this.phoneNumber);
      this.isSubmitClicked = true;
    } else {
      this.generateOtpAndProceed();
    }
  }

  generateOtpAndProceed(): void {
    this.isLoading = true;

    this.otpService.generateOtp(this.phoneNumber).subscribe(
      response => {
        this.isLoading = false;
        if (response && response.metaData.responseCode === 'OK') {
          this.router.navigate(['/verify-otp'], {
            queryParams: {
              phoneNumber: this.phoneNumber,
              isEditFlow: this.isEditFlow
            }
          });
        } else {
          this.snackBar.open(response?.metaData.responseCode || 'Failed to send OTP. Please try again.', 'Dismiss', { duration: 5000 });
          console.error('API response for OTP generation failed:', response);
        }
      },
      error => {
        this.isLoading = false;
        this.snackBar.open(error.error?.metaData.responseCode === 'TOO_MANY_REQUESTS' ? 'Too many requests. Please try again after 5 minutes.' : 'An error occurred while sending OTP. Please try again later.', 'Dismiss', { duration: 5000 });
        console.error('Error generating OTP:', error);
      }
    );
  }

  searchExistingRetailers(phoneNumber: string): void {
    this.isLoading = true;
    this.existingRetailers = [];
    const filters: RetailerFilter = {};
    filters.searchString = phoneNumber;
    this.retailerService.getRetailers(this.pageIndex, this.pageSize, filters).subscribe(
      response => {
        this.isLoading = false;
        if (response && response.data && response.metaData.responseCode === '200 OK') {
          this.existingRetailers = response.data.retailers;
          if (this.existingRetailers && this.existingRetailers.length > 0) {
            this.showExistingRetailers = true;
            this.router.navigate(['/view-existing-retailers'], { state: { dealers: this.existingRetailers, phoneNumber: this.phoneNumber, isEditFlow: this.isEditFlow } });
          } else {
            this.showExistingRetailers = false;
            this.generateOtpAndProceed();
          }
        } else {
          this.showExistingRetailers = false;
          this.showExistingRetailers = false;
          this.generateOtpAndProceed();
        }
      },
      error => {
        this.isLoading = false;
        this.showExistingRetailers = false;
        console.error('Error searching existing retailers:', error);
        this.showExistingRetailers = false;
        this.generateOtpAndProceed();
      }
    );
  }

  selectExistingRetailer(retailer: RegisteredRetailer): void {
    this.retailerDataStore.setRetailer(retailer);
    this.snackBar.open(`Selected existing dealer: ${retailer.retailerName}`, 'Dismiss', { duration: 2000 });
    this.router.navigate(['/view-dealer-details'], { state: { dealer: retailer } });
  }

  goBack(): void {
    this.location.back();
  }
}